import React from 'react';
import { useRootSelector } from '../../../../../store/hooks';
import {
  selectPageConfig,
  TenantDomainId,
} from '../../../../../store/features/pageConfig';
import DataCenterWorldFooterEventInfo from './DataCenterWorldFooterEventInfo';
import DataCenterWorldFooterEventSeries from './DataCenterWorldFooterEventSeries';
import DataCenterWorldFooterSocial from './DataCenterWorldFooterSocial';
import DataCenterWorldFooterLegal from './DataCenterWorldFooterLegal';
import {
  contentConfig,
  GLOBAL_EVENT_SERIES,
  EventSeriesLink,
} from './constants';

import './DataCenterWorldFooter.scss';

function getEventSeriesLinks(
  tenantId: TenantDomainId | null | undefined,
): EventSeriesLink[] {
  return GLOBAL_EVENT_SERIES.filter((event) => event.id !== tenantId);
}

export function DataCenterWorldFooter() {
  const { tenantId } = useRootSelector(selectPageConfig);
  const config = tenantId && contentConfig[tenantId];

  if (!config) return null;

  return (
    <footer className="c-dcw-footer">
      <div className="container">
        <div className="c-dcw-footer__columns row">
          <div className="col-xs-12 col-sm-4">
            <DataCenterWorldFooterEventInfo config={config} />
          </div>
          <div className="col-xs-12 col-sm-4">
            <DataCenterWorldFooterEventSeries
              events={getEventSeriesLinks(tenantId)}
            />
          </div>
          <div className="col-xs-12 col-sm-4">
            <DataCenterWorldFooterSocial />
          </div>
        </div>
        <DataCenterWorldFooterLegal termsHref={config.termsHref} />
      </div>
    </footer>
  );
}

export default DataCenterWorldFooter;
